import React, { useContext, useMemo } from 'react'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import {
  freeEditEngine,
  Grid,
  virtualizedGridRenderer,
  // freeEditEngine,
} from '@integec/grid-tools'
import { rowHeaderRender } from 'core/utils'
import { getEventDataHeaders } from './../margin-client'
import { strCol } from '@integec/grid-tools/lib/cols'
import { Checkbox } from 'antd'

const EventDataWF = props => {
  const {
    WFRetrieveData,
    setWFSelectedEvents,
    eventDataEditInfo,
    setEventDataEditInfo,
    // clearEventDataEditInfo,
  } = useContext(MarginAnalysisContext)

  const { width, height, CLIENT, writePermission } = props
  const { events } = WFRetrieveData

  const updateData = ({ currentRow, editedRow }) => {
    const editInfo = freeEditEngine.updateRow({
      editInfo: eventDataEditInfo,
      currentRow,
      editedRow,
    })
    setEventDataEditInfo(editInfo)
  }
  // const [data, setData] = useState(events)
  const OaEventIoHeaders = getEventDataHeaders(CLIENT)(width)
  const boolCheckHeader = strCol({
    ident: 'action',
    display: 'Included',
    isEditable: true,
    width: 100,
    dataFormatter: ({ rowData, value }) => (
      <Checkbox
        checked={value === 'Y'}
        onChange={e =>
          updateData({
            currentRow: rowData,
            editedRow: { ...rowData, action: e.target.checked ? 'Y' : 'N' },
          })
        }
        disabled={!writePermission}
      />
    ),
  })

  const header = useMemo(_ => [boolCheckHeader, ...OaEventIoHeaders], [
    OaEventIoHeaders,
    boolCheckHeader,
  ])

  const selectionChange = ({ selectedRows }) => {
    setWFSelectedEvents(selectedRows[0])
  }
  const isEditable = ({ header }) => {
    return header.ident === 'action'
  }

  return (
    <div style={{ minHeight: height < 300 ? '200px' : height + 'px' }}>
      <Grid
        data={events || []}
        headers={header}
        // header={header}
        altBgColor="#ebebeb"
        render={virtualizedGridRenderer({
          // autoFixColByKey,
          rowHeaderRender,
          height: height < 200 ? 200 : height,
          width,
          headerRowHeight: 30,
          isEditable: isEditable,
        })}
        height={height}
        width={width}
        onSelectionChange={selected => {
          selectionChange(selected)
        }}
        // initialSortOptions={sortOptions}
        // sortOptions={sortOptions}
        // sortEnabled={sortEnabled}
        // isEditable={isEditable}
        editInfo={eventDataEditInfo}
        // setEditInfo={updateData}
        // onEditInfoChange={updateData}
        editMode="cell"
        selectionType="row"
        selectionMode="single"
      />
    </div>
  )
}

export default EventDataWF
